import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants";
import { AboutUsData } from "../../content.types";

export const requestUpdateAboutUs = async (
  body: AboutUsData
): Promise<AboutUsData> => {
  return await instance.post(ApiRoutesContent.AboutUs, body);
};
